import { render, staticRenderFns } from "./PublicApp.vue?vue&type=template&id=08fc749c&"
import script from "./PublicApp.vue?vue&type=script&lang=ts&"
export * from "./PublicApp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports